<template>
    <div>
        <h1 class="text-danger">Error.</h1>
        <h2 class="text-danger">An error occurred while processing your request.</h2>

        <p v-if="errorMessage">
            {{errorMessage}}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            errorMessage: {
                type: String,
                required: false
            }
        }
    }
</script>
